module.exports = __webpack_public_path__ + "img/logo-artmed360.b4c89446.svg";